import { getDocs, limit, orderBy, query, startAfter } from 'firebase/firestore'
import { CompanyPlanningRecordLetter } from '@leadgen/models/client'
import firestore from '../../firestore'
import BaseService from '../BaseService'

class CompanyPlanningRecordLetterService extends BaseService {
  readonly pageSize = 50

  fetchCompanyPlanningRecordLetters = async ({
    companyId,
  }: {
    companyId: string
  }): Promise<CompanyPlanningRecordLetter[]> => {
    const companyPlanningRecordLettersSnapshot = await getDocs(
      firestore.companyPlanningRecordLetters(companyId),
    )
    return companyPlanningRecordLettersSnapshot.docs.map(companyPlanningRecordLetterDoc =>
      companyPlanningRecordLetterDoc.data(),
    )
  }

  fetchCompanyPlanningRecordLettersFirstPage = async ({
    companyId,
    onCompanyPlanningRecordLetterAdded,
    onCompanyPlanningRecordLetterUpdated,
  }: {
    companyId: string
    onCompanyPlanningRecordLetterAdded: (template: CompanyPlanningRecordLetter) => void
    onCompanyPlanningRecordLetterUpdated: (template: CompanyPlanningRecordLetter) => void
  }) => {
    const { data, unsubscribe } = await this.onSnapshot({
      query: query(
        firestore.companyPlanningRecordLetters(companyId),
        orderBy('processedTimestamp', 'desc'),
        limit(this.pageSize),
      ),
      onUpdated: onCompanyPlanningRecordLetterUpdated,
      onAdded: onCompanyPlanningRecordLetterAdded,
    })
    return {
      data,
      unsubscribe,
    }
  }

  fetchCompanyPlanningRecordLettersNextPage = async ({
    companyId,
    startAfter: startAfterTimestamp,
    onCompanyPlanningRecordLetterUpdated,
  }: {
    companyId: string
    startAfter: Date
    onCompanyPlanningRecordLetterUpdated: (template: CompanyPlanningRecordLetter) => void
  }) => {
    const { data, unsubscribe } = await this.onSnapshot({
      query: query(
        firestore.companyPlanningRecordLetters(companyId),
        orderBy('processedTimestamp', 'desc'),
        startAfter(startAfterTimestamp),
        limit(this.pageSize),
      ),
      onUpdated: onCompanyPlanningRecordLetterUpdated,
    })
    return {
      data,
      unsubscribe,
    }
  }
}

export default new CompanyPlanningRecordLetterService()
